import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../../services/Api';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';

const ProdutoApresentacaoContext = createContext();

export const useProdutoApresentacao = () => useContext(ProdutoApresentacaoContext);

export const ProdutoApresentacaoProvider = ({ children }) => {
    const [produtoApresentacoes, setProdutoApresentacoes] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchProdutoApresentacoes = useCallback(async (produtoId) => {
        if (!produtoId) {
            setProdutoApresentacoes([]);
            return;
        }

        try {
            const result = await fetchData(`/ProdutoApresentacao/GetTodosCadByProdutoId?produtoId=${produtoId}`);
            setProdutoApresentacoes(result);
        } catch (error) {
            console.error("Erro ao buscar apresentações do produto:", error);
            showMessage(`Erro ao buscar apresentações do produto! ${error?.message || error}`, 'danger');
        }
    }, [showMessage]);

    useEffect(() => {
        fetchProdutoApresentacoes();
    }, [fetchProdutoApresentacoes]);

    const addProdutoApresentacao = async (item) => {
        try {
            const result = await postData('/ProdutoApresentacao', item);
            setProdutoApresentacoes([...produtoApresentacoes, result]);
            showAlert('Apresentação adicionada ao produto com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar apresentação ao produto:", error);
            showMessage('Erro ao adicionar apresentação ao produto!\n' + error, 'danger');
        }
    };

    const updateProdutoApresentacao = async (item) => {
        try {
            const result = await putData('/ProdutoApresentacao', item);
            setProdutoApresentacoes((prev) =>
                prev.map((i) => (i.id === result.id ? result : i))
            );
            showAlert('Apresentação do produto alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar apresentação do produto:", error);
            showAlert('Erro ao alterar apresentação do produto!', 'danger');
        }
    };

    const deleteProdutoApresentacao = async (id) => {
        try {
            await deleteData('/ProdutoApresentacao', { id });
            setProdutoApresentacoes(produtoApresentacoes.filter(i => i.id !== id));
            showAlert('Apresentação do produto excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir apresentação do produto:", error);
            showAlert('Erro ao excluir apresentação do produto!', 'danger');
        }
    };

    return (
        <ProdutoApresentacaoContext.Provider value={{
            produtoApresentacoes,
            addProdutoApresentacao,
            updateProdutoApresentacao,
            deleteProdutoApresentacao,
            fetchProdutoApresentacoes
        }}>
            {children}
        </ProdutoApresentacaoContext.Provider>
    );
};